import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { getSnackbarSelector } from '@store/snackbars/snackbars.selectors';
import { SnackbarsService } from '@services';
import { Snackbars } from '@enums';
import { Icon } from '@elements';
import { SnackbarAlert, StyledSnackbar } from './snackbar.styles';
import ErrorIcon from '@images/ep-alert.svg';
import SuccessIcon from '@images/ep-success.svg';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

/**
 * Snackbar component.
 *
 * @author Mikhail Siutsou
 * @function SnackbarComponent
 * @category components
 * @param {string} snackbarId snackbar id.
 * @return {FC} snackbar component.
 */
var SnackbarComponent = function SnackbarComponent(_ref) {
  var _snackBar$data, _snackBar$data2, _snackBar$data3;

  var snackbarId = _ref.snackbarId;
  var snackBar = useSelector(getSnackbarSelector(snackbarId));
  /**
   * Reject snackbar.
   *
   * @author Mikhail Siutsou
   * @return {void}
   */

  var rejectSnackbar = useCallback(function () {
    SnackbarsService.close(snackbarId);
  }, [snackbarId]);
  /**
   * Close snackbar.
   *
   * @author Mikhail Siutsou
   * @return {void}
   */

  var handleClose = useCallback(function () {
    rejectSnackbar();
  }, [rejectSnackbar]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(StyledSnackbar, {
      open: snackBar && snackBar.isOpen ? snackBar.isOpen : false,
      autoHideDuration: 3000,
      onClose: handleClose,
      anchorOrigin: {
        vertical: (snackBar === null || snackBar === void 0 ? void 0 : (_snackBar$data = snackBar.data) === null || _snackBar$data === void 0 ? void 0 : _snackBar$data.vertical) || 'top',
        horizontal: (snackBar === null || snackBar === void 0 ? void 0 : (_snackBar$data2 = snackBar.data) === null || _snackBar$data2 === void 0 ? void 0 : _snackBar$data2.horizontal) || 'left'
      },
      ClickAwayListenerProps: {
        onClickAway: function onClickAway() {// empty
        }
      },
      children: /*#__PURE__*/_jsx(SnackbarAlert, {
        severity: snackbarId === Snackbars.Success ? 'success' : 'error',
        sx: {
          width: '100%'
        },
        iconMapping: {
          success: /*#__PURE__*/_jsx(Icon, {
            src: SuccessIcon,
            width: 24,
            height: 24
          }),
          error: /*#__PURE__*/_jsx(Icon, {
            src: ErrorIcon,
            width: 24,
            height: 24
          })
        },
        children: (snackBar === null || snackBar === void 0 ? void 0 : (_snackBar$data3 = snackBar.data) === null || _snackBar$data3 === void 0 ? void 0 : _snackBar$data3.title) || ''
      })
    })
  });
};

export { SnackbarComponent };